import Page from "../components/Page";
import CaseGallery from "../components/CaseGallery";
import { CASES_SUBTITLE } from "../data/caseImages";

export default function Cases() {
	return (
		<Page title="Cases" subtitle={CASES_SUBTITLE}>
			<CaseGallery />
		</Page>
	);
}
